export default __webpack_public_path__ + "static/media/top20-badge.bd6995cb.svg";